export const isValidEmail = (email: string) => {
  // This regex is a good balance between complexity and correctness.
  // It allows for TLDs of 2 or more characters, and handles subdomains.
  // It doesn't cover all edge cases, but is sufficient for most common email formats.
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};
